// console.log('CF7 Events Loaded');

document.addEventListener( 'wpcf7mailsent', function( event ) {
    // Contact Form
    if ( '5053' == event.detail.contactFormId ) {
        var entity = document.querySelector('#property').value; 
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'submit_claim',
            'company' : entity
        });
    }
    // Contact Form
    if ( '168' == event.detail.contactFormId ) {
        var subject = document.querySelector('#contact-subject').value; 
           window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'contactForm',
                'subject' : subject 
            });
    }

}, false );

